export default theme => ({
  header: theme.headerTitle,
  stepContainer: {
    maxWidth: 600
  }
});
